import { render } from "./LoyaltyCard.vue?vue&type=template&id=1eded04e&scoped=true"
import script from "./LoyaltyCard.vue?vue&type=script&lang=js"
export * from "./LoyaltyCard.vue?vue&type=script&lang=js"

import "./LoyaltyCard.vue?vue&type=style&index=0&id=1eded04e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1eded04e"]])

export default __exports__